import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useLocation, useHistory } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import ModalComponent from "../../Components/ModalComponent";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);

  const [value, setValue] = useState();
  const [file, setFile] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [validationISEE, setValidationISEE] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [isOpenRefuse, toggleModalRefuse] = useState(false);
  const [data, setData] = useState({});
  const [id, setId] = useState(null);
  const [iseeData, setIseeData] = useState(null);
  const isError = iseeData?.state === "ERROR";
  const isLocked = !!iseeData?.usedInPayment;

  const query = useQuery();
  const [selected, setSelected] = useState("ordinario");

  const toNumber = (v) => {
    if (v === null || v === undefined || v === "") return null;
    const n = typeof v === "number" ? v : parseFloat(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };

  const toDateInput = (v) => {
    if (!v) return "";
    const s = String(v).trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10);
    const datePart = s.split(" ")[0];
    if (datePart.includes("/")) {
      const parts = datePart.split("/");
      if (parts.length === 3) {
        const [d, m, y] = parts;
        return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      }
    }
    return "";
  };

  const sameValue = (a, b) => {
    const na = toNumber(a);
    const nb = toNumber(b);
    if (na === null || nb === null) return false;
    return Math.abs(na - nb) < 0.005;
  };

  const formatIseeAmount = (v) => {
    const n = toNumber(v);
    if (n === null) return "N/A";
    return n.toLocaleString("it-IT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const resolveSelectedType = (data) => {
    const ristretto = toNumber(data?.ristretto);
    const ordinario = toNumber(data?.ordinario);
    const current = toNumber(data?.value);

    if (sameValue(ristretto, ordinario)) {
      return "ordinario";
    }
    if (ristretto !== null && current !== null && sameValue(current, ristretto)) {
      return "ristretto";
    }
    return "ordinario";
  };

  const handleChange = (event) => {
    const type = event.target.value;
    setSelected(type);
    if (type === "ordinario") {
      setValue(iseeData?.ordinario);
    } else if (type === "ristretto") {
      setValue(iseeData?.ristretto);
    } else {
      setValue(iseeData?.value);
    }
  };

  const selectedValue =
    selected === "ordinario"
      ? iseeData?.ordinario
      : selected === "ristretto"
        ? iseeData?.ristretto
        : selected === "dichiarato"
          ? iseeData?.value
          : null;

  const loadIsee = async (iseeId) => {
    const response = await Repo.getIsee(apiToken, iseeId);
    if (response.status === 200) {
      console.log("response", response.data);
      //  setFile("data:application/pdf;base64," + response.data.file);
      var obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64,";
      obj.length = 0;
      setFile(obj);
      obj.data = "data:application/pdf;base64," + response.data.file;
      obj.length = response.data.file.length;
      setFile(obj);
      const data = {
        ...response.data,
        date: toDateInput(response.data.date),
        scadenza: toDateInput(response.data.scadenza),
      };
      setUserData(data.user);
      const type = resolveSelectedType(data);
      setSelected(type);
      const copied =
        type === "ristretto"
          ? data.ristretto
          : type === "ordinario"
            ? data.ordinario
            : data.value;
      setValue(copied ?? data.value ?? "");
      setIseeData(data);
      console.log("Isee data:", data);
    }
  };

  const idIsee = query.get("idIsee");

  useEffect(() => {
    if (!idIsee) return;

    setId(idIsee);

    const loadData = async () => {
      setLoading(true);
      try {
        await loadIsee(idIsee);
      } catch (err) {
        console.error("Errore durante il caricamento ISEE:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [idIsee]);

  const confirmIsee = () => {
    setValidation(true);
    toggleModal(true);
  };

  const refuseIsee = () => {
    setValidation(true);
    toggleModalRefuse(true);
  };

  const sendISEEApi = async (stateToSet) => {
    const payload = {
      id: idIsee || id,
      userId: iseeData?.user?.id,
      state: Number(stateToSet),
      value: toNumber(value) ?? selectedValue,
      protocollo: iseeData?.protocollo,
      date: toDateInput(iseeData?.date) || null,
      scadenza: toDateInput(iseeData?.scadenza) || null,
    };

    try {
      const response = await Repo.postConfirmIsee(apiToken, payload);

      if (response.status === 200) {
        const redirectTo =
          process.env.PUBLIC_URL +
          `/lista_utenti/dati_utente?citizen=${iseeData.user.id}`;

        window.location.href = redirectTo;
      } else {
        alert("Errore durante la conferma dell'ISEE");
      }
    } catch (error) {
      console.error("Errore nell'invio dell'ISEE:", error);
      const msg =
        error?.response?.data ||
        "Errore tecnico durante la conferma dell'ISEE";
      alert(typeof msg === "string" ? msg : "Errore tecnico durante la conferma dell'ISEE");
    }
  };

  const history = useHistory();
  return (
    <>
      <div>
        <h1>Verifica ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>
            Verifica gli ISEE caricati dagli utenti confronta il valore inserito
            con quello estratto dal documento PDF
          </p>
        </div>

        <div className="row mb-2">
          <div className="col-12"></div>
        </div>
        <div className="row">
          <ViewPDF data={file && file.data} length={file && file.length} />

          <div className="col-lg-4 pl-5">
            {isLocked && (
              <div className="alert alert-warning">
                ISEE utilizzato in un pagamento: non modificabile né
                cancellabile.
              </div>
            )}
            <h3>Riepilogo utente</h3>

            <div>
              Nome cognome:
              <div className="clear"></div>
              <strong>
                {userData && userData.firstName + " " + userData.lastName}
              </strong>
              <div className="clear"></div>
              Codice Fiscale: <div className="clear"></div>
              <strong>
                <Link
                  to={`/lista_utenti/dati_utente?citizen=${iseeData?.user?.id}`}
                >
                 {userData?.fiscalCode}
                </Link> 


              </strong>
              <div className="clear"></div>
              Email:
              <div className="clear"></div>
              <strong>{userData && userData.email}</strong>
            </div>

            <hr />

            <div className="clear"></div>
            {isError && (
              <div className="alert alert-warning">
                {iseeData?.omissioneDifformita ||
                  iseeData?.detail ||
                  "Errore Isee"}
              </div>
            )}
            {!isError && iseeData?.omissioneDifformita && (
              <div className="alert alert-danger">
                <strong>Omissione/Difformità:</strong>
                <div className="mt-1">{iseeData.omissioneDifformita}</div>
              </div>
            )}
            <p className="mt-2">Protocollo ISEE estratto in automatico:</p>
            <div className="row mb-4">
              <Input
                id="valueProtocollo"
                type="text"
                value={iseeData?.protocollo ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    protocollo: e.target.value,
                  })
                }
              />
            </div>

            <div className="clear"></div>
            <p className="mt-2">Data rilascio ISEE</p>
            <div className="row mb-4">
              <Input
                id="date"
                type="date"
                value={iseeData?.date ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    date: e.target.value,
                  })
                }
              />
            </div>

            <div className="clear"></div>
            <p className="mt-2">Scadenza ISEE</p>
            <div className="row mb-4">
              <Input
                id="scadenza"
                type="date"
                value={iseeData?.scadenza ?? ""}
                onChange={(e) =>
                  setIseeData({
                    ...iseeData,
                    scadenza: e.target.value,
                  })
                }
              />
            </div>

            <div>
              <label>
                <input
                  type="radio"
                  name="tipoIsee"
                  value="ordinario"
                  checked={selected === "ordinario"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Ordinario ({formatIseeAmount(iseeData?.ordinario)})
              </label>
              <br />
              <label>
                  <input
                  type="radio"
                  name="tipoIsee"
                  value="ristretto"
                  checked={selected === "ristretto"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Ristretto ({formatIseeAmount(iseeData?.ristretto)})
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  name="tipoIsee"
                  value="dichiarato"
                  checked={selected === "dichiarato"}
                  onChange={handleChange}
                />
                &nbsp;ISEE Dichiarato ({formatIseeAmount(iseeData?.value)})
              </label>

              <div style={{ marginTop: "1rem" }}>
                <strong>ISEE Selezionato:</strong>
              </div>
              <div className="row mb-4 mt-2">
                <Input
                  id="valueIsee"
                  type="number"
                  value={value ?? ""}
                  onChange={(e) => setValue(e.target.value)}
                />
              </div>
            </div>

            <div className="clear"></div>

            <div className="row mb-4"></div>
            <div className="d-flex justify-content-around">
              <div>
                <button
                  type="button "
                  className="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="top"
                  onClick={() => confirmIsee()}
                  title="Conferma"
                  disabled={isLocked}
                >
                  Conferma
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-warning"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Rifiuta"
                  onClick={() => refuseIsee()}
                  disabled={isLocked}
                >
                  Rifiuta
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Indietro"
                  onClick={() => history.goBack()}
                >
                  Indietro
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi(1)}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalRefuse}
        isOpen={isOpenRefuse}
        header="Rifiuto ISEE"
        body="Confermi di voler rifiutare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendISEEApi(2)}
      ></ModalComponent>

      {loading && <Loader></Loader>}
    </>
  );
}

export default CheckISEE;
